<template>
  <form @submit.prevent="onClose" class="col-sm-12">
    <div class="col-sm-12">
      <FieldDate name="Date" rules="required" v-model="value.date_result" />
    </div>
    <div class="col-sm-12">
      <FieldTextArea name="Result" :rows="6" rules="required" v-model="value.result" />
    </div>
    <div class="row mt-2">
      <div class="col-sm-12">
        <button type="submit" class="btn btn-orange w-100">Submit</button>
      </div>
    </div>
  </form>
</template>
<script>
import FieldDate from '@/components/field/Date.vue';
import FieldTextArea from '@/components/field/TextArea.vue';

export default {
  name: "FormFeedbackCustomerIssue",
  components: {
    FieldDate,
    FieldTextArea
  },
  props: ['value'],
  methods: {
    async onClose() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.$emit('close')
      }
    }
  }
}
</script>
